import React, { useState, useEffect } from "react";
import { Box, TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button} from "@mui/material";
import {useSelector} from "react-redux"
import Task01CreateDialog from "./Task01CreateDialog"
import { CsqaType } from "../../admin/vie/task/csqa/CsqaTable";
import CustomPagination from "../../component/common/CustomPagination";
import Task01DetailDialog from "../task/task-01/Task01DetailDialog";
import Task02DetailDialog from "../task/task-02/Task02DetailDialog";
import Task03DetailDialog from "../task/task-03/Task03DetailDialog";
import Task04DetailDialog from "../task/task-04/Task04DetailDialog";
import Task05DetailDialog from "../task/task-05/Task05DetailDialog";
import Task06DetailDialog from "../task/task-06/Task06DetailDialog";
import Task07DetailDialog from "../task/task-07/Task07DetailDialog";
import Task08DetailDialog from "../task/task-08/Task08DetailDialog";
import Task09DetailDialog from "../task/task-09/Task09DetailDialog";
import Task10DetailDialog from "../task/task-10/Task10DetailDialog";
import Task02CreateDialog from "./Task02CreateDialog";
import Task03CreateDialog from "./Task03CreateDialog";
import Task04CreateDialog from "./Task04CreateDialog";
import Task05CreateDialog from "./Task05CreateDialog";
import Task06CreateDialog from "./Task06CreateDialog";
import Task07CreateDialog from "./Task07CreateDialog";
import Task08CreateDialog from "./Task08CreateDialog";
import Task09CreateDialog from "./Task09CreateDialog";
import Task10CreateDialog from "./Task10CreateDialog";


interface pageInfoType {
  current_page: number;
  total_pages: number;
  total_count: number;
}

const VieCreateListPage = (props:any) => {

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)
  
  const [work_type, setWork_type] = useState<string>('NEW')

  const [data, setData] = useState<any>(undefined);

  const [pagination, setPagination] = useState<pageInfoType | undefined>(
    undefined
  );
  
  const updateAfter = () => {
    setData(undefined);
    props.vieWorkList(props.task);
  }

  useEffect(() => {
    if(props.workList.pagination != undefined){
      setPagination(props.workList.pagination)
    }
  },[props])

  return (
    <Box>
      {/* Task 단위 화면 */}
      <Box display="flex" justifyContent="center" >
        <Box sx={{padding:"20px 8px 8px 8px", width:"400px"}}>
          <Box display="flex">
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task-{props.task}. 작성목록</Box>
            <Button variant="contained" size="small" sx={{fontWeight:700, margin:"4px 8px", marginLeft:"auto", backgroundColor:"#FF9800"}}
                onClick={() => {
                  setWork_type('NEW')
                }}
              >
                신규작성
            </Button>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
          <TableContainer sx={{maxHeight:"680px",fontSize:"12px"}}>
            <Table size="small" aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>CONCEPT</Box></TableCell>
                  <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>USE_CHECK</Box></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {(props.workList.datas != undefined && props.workList.datas.length > 0) ? props.workList.datas.map((row:any, index:number) => (
                <TableRow
                  key={index}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 }, cursor: 'pointer', ':hover': { backgroundColor: '#e1e1ee' } , backgroundColor:(data != undefined && row.idx === data.idx ? "#dbdbef": "#fff")}}
                  onClick={()=> {setWork_type('DETAIL'); setData(row);}}
                >
                  <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                  <TableCell align="left">{row.concept_en}</TableCell>
                  <TableCell align="left">
                    <Box sx={{width:"58px",fontSize:"14px", marginLeft:"8px", padding: "2px 6px 2px 6px", borderRadius:"4px",
                        border: (row.use_check === "F" ? "2px solid red" : (row.use_check === "T" ? "2px solid #498ad5" : (row.use_check === "C" ? "2px solid #27cc2f" : "#bbb"))), color:"#000" }}>
                      {(row.use_check === "T" ? "사용가능" : (row.use_check === "F" ? "사용불가" : (row.use_check === "C" ? "내용수정":"미분류")))}
                    </Box>
                  </TableCell>
                </TableRow>
                )):<TableRow><TableCell colSpan={3} component="th" scope="row" align="center">데이터가 없습니다.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{marginTop:"12px"}}>
            {pagination !== undefined ? (
                <CustomPagination pagination={pagination} goPage={props.goPage} />
            ) : ""}
          </Box>
        </Box>

        {props.task == '01' && work_type == 'NEW' ? <Task01CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '01' && work_type == 'DETAIL' ? <Task01DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'} />:<></>}
        {props.task == '02' && work_type == 'NEW' ? <Task02CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '02' && work_type == 'DETAIL' ? <Task02DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '03' && work_type == 'NEW' ? <Task03CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '03' && work_type == 'DETAIL' ? <Task03DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '04' && work_type == 'NEW' ? <Task04CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '04' && work_type == 'DETAIL' ? <Task04DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '05' && work_type == 'NEW' ? <Task05CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '05' && work_type == 'DETAIL' ? <Task05DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '06' && work_type == 'NEW' ? <Task06CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '06' && work_type == 'DETAIL' ? <Task06DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '07' && work_type == 'NEW' ? <Task07CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '07' && work_type == 'DETAIL' ? <Task07DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '08' && work_type == 'NEW' ? <Task08CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '08' && work_type == 'DETAIL' ? <Task08DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '09' && work_type == 'NEW' ? <Task09CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '09' && work_type == 'DETAIL' ? <Task09DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
        {props.task == '10' && work_type == 'NEW' ? <Task10CreateDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} />:<></>}
        {props.task == '10' && work_type == 'DETAIL' ? <Task10DetailDialog rowDetail={data} updateAfter={updateAfter} worker={worker} work_yn={props.work_yn} createVie={'true'}/>:<></>}
      </Box>
    </Box>


  );
};

export default VieCreateListPage;
